import React, { useEffect, useState } from 'react';
import { IoMdCreate } from "react-icons/io";
import { IoIosCheckmark } from "react-icons/io";
import { Api } from '../../../../services/api';
import { Editor } from 'primereact/editor'; // Import the Editor component

function MarketStrategy() {
  const [isEditing, setIsEditing] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false); // Admin check
  const [formData, setFormData] = useState({
    dYaerTarget: [
      {
        description: '',
      },
    ],
  });

  useEffect(() => {
    fetchData();
    const adminStatus = localStorage.getItem('isAdmin');
    setIsAdmin(adminStatus === 'Y');
  }, []);

  const fetchData = async () => {
    try {
      const token = localStorage.getItem('authToken');
      const response = await fetch(Api.API_BASE_URL + 'business-core/vision/ten-year-plan/get', {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': token ? `Bearer ${token}` : '',
        },
      });
      const data = await response.json();
      if (Array.isArray(data.result)) {
        const mappedData = data.result.map(item => ({
          description: item.description || ''
        }));
        setFormData({ dYaerTarget: mappedData.length > 0 ? mappedData : [{ description: '' }] });
      } else {
        setFormData({ dYaerTarget: [{ description: '' }] });
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const handleEditToggle = () => {
    if (isEditing) {
      handleSave();
    } else {
      setIsEditing(true);
    }
  };

  const handleSave = async () => {
    setIsEditing(false);
    try {
      const token = localStorage.getItem('authToken');
      const payload = {
        ten_year_target: formData.dYaerTarget // Wrap corefocus inside the payload
      };

      const response = await fetch(Api.API_BASE_URL + 'business-core/vision/ten-year-plan/save', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': token ? `Bearer ${token}` : ''
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        throw new Error('Network response was not ok');
      }

      const result = await response.json();
      console.log('Data saved successfully:', result);
    } catch (error) {
      console.error('Error saving data:', error);
    }
  };

  const handleChange = (e, field) => {
    const newDYaerTarget = [...formData.dYaerTarget];
    newDYaerTarget[0][field] = e.htmlValue; // Update the first (and only) row
    setFormData({
      ...formData,
      dYaerTarget: newDYaerTarget,
    });
  };

  return (
    <div className="box2">
      <div className="box-header">
        <h4 className='title-font'>10-Year Target™ </h4>
        {isAdmin && (
          <div onClick={handleEditToggle} style={{ cursor: 'pointer' }}>
            {isEditing ? (
              <IoIosCheckmark
                style={{
                  fontSize: '40px',
                }}
              />
            ) : (
              <IoMdCreate
                style={{
                  fontSize: '20px',
                }}
              />
            )}
          </div>
        )}
      </div>

      <div className="box-body" >
        {formData.dYaerTarget.map((row, index) => (
          <div key={index}>
            <div className="p-2">
              {isEditing ? (
                <>
                  <label htmlFor={`description-${index}`} style={{ display: 'block', marginBottom: '10px', fontSize: '14px', fontWeight: '400' }}>
                    Description*
                  </label>
                  <Editor
                    id={`description-${index}`}
                    value={row.description}
                    onTextChange={(e) => handleChange(e, 'description')}
                    style={{ height: '220px', width: '100%' }}
                  />
                </>
              ) : (
                <div dangerouslySetInnerHTML={{ __html: row.description }} />
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default MarketStrategy;